export default "__VITE_ASSET__a4UBzSRS__"